module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'loggedRole-' + _vm.loggedRole,
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden && _vm.isLogged
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-250a12e4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue
// module id = 234
// module chunks = 42